import SalaryPageTemplate from "@/components/SalaryPageTemplate";
import { SALARY_DATA } from "@/data/salaryData";

export default function DataEngineerSalary() {
  return <SalaryPageTemplate data={SALARY_DATA["data-engineer"]} />;
}
